<template>
    <div class="date-format-picker">
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" />
            <span class="material-icons"> search </span>
        </div>
        <div class="entity-list">
            <div class="entity-select">
                <div class="text-uppercase caption">{{$t("automation.dataFormats")}}</div>
                <div
                    class="picker-item"
                    v-for="item of list"
                    @click="pick(item.value)"
                    :class="{ active: value === item.value }"
                >
                    <span class="name">{{ item.description }} </span>
                    <span class="description">{{ item.example }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment-timezone";
import _ from "lodash";

export default {
    name: "DateFormatPicker",
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        const formats = [
            "ddd MMM DD HH:mm:ss Z YYYY##(Sun Jan 22 23:04:05 -0000 2006)",
            "MMMM DD YYYY HH:mm:ss##(January 22 2006 23:04:05)",
            "MMM DD YYYY##(Jan 22 2006)",
            "YYYY-MM-DDTHH:mm:ssZ##(2006-01-22T23:04:05-0000)",
            "YYYY-MM-DD HH:mm:ss Z##(2006-01-22 23:04:05 -0000)",
            "YYYY-MM-DD##(2006-01-22)",
            "MM-DD-YYYY##(01-22-2006)",
            "MM/DD/YYYY##(01/22/2006)",
            "MM/DD/YY##(01/22/06)",
            "DD-MM-YYYY##(22-01-2006)",
            "DD/MM/YYYY##(22/01/2006)",
            "DD/MM/YY##(22/01/06)",
            "DD/MM/YY HH:mm##(22/01/24 23:04)",
            "DD/MM/YY HH:mm:ss##(13/01/24 23:04:05)",
            "DD/MM/YYYY HH:mm##(22/01/2024 23:04)",
            "DD/MM/YYYY HH:mm:ss##(22/01/2024 23:04:05)",
            "YYYY-MM-DDTHH:mm:ssZ##(2006-01-02T15:04:05Z)",
            "YYYY-MM-DDTHH:mm:ss.SSSZ##(2006-01-02T15:04:05.999Z)",
            "Timestamp##(1137971045)",
        ];
        return {
            list: formats.map((x) => ({
                value: x.split("##")[0],
                description: x.split("##")[0],
                example: x.split("##")[1],
            })),
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        pick(value) {
            this.clone = value;
        },
    },
    computed: {
        ...mapState({}),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (newValue !== this.clone) this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss">
.date-format-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .entity-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 0;
    }

    .entity-select {
        .caption {
            margin-bottom: 10px;
            padding: 0 15px;
            color: #9ba6b3;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 15px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons {
            color: #647283;
            font-size: 15px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 20px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
